var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('p',[_vm._v(" Copyright © 1998 - "+_vm._s(_vm.now)+" TENCENT. All Rights Reserved. "),_c('br'),_vm._v("腾讯公司 S2-财经线/财经IT管理部 ")])])}
var staticRenderFns = []

export { render, staticRenderFns }